export default __webpack_public_path__ + "fa915ca6030a10ba6feb4cefeb66c538.png";